export default __webpack_public_path__ + "static/media/cross_grey_icon.c3279d16.svg";